/** @file Linear interpolation between two vectors. */
import type { Vec3 } from './vec3';

/** `a + (b - a) * t`; t = 0 gives a, t = 1 gives b. */
export function vec3Lerp(a: Vec3, b: Vec3, t: number): Vec3 {
  return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
}
